import React, { useState, useEffect, useCallback } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, ModalButton } from "baseui/modal";
import { Block } from "baseui/block";
import { Input } from "baseui/input";
import { Checkbox } from "baseui/checkbox";
import { useTranslation } from "react-i18next";

export const SellModal = ({ isOpen, onClose, onCreateProduct }) => {
  const { t } = useTranslation("template");
  const [price, setPrice] = useState("");
  const [includeTemplate, setIncludeTemplate] = useState(false);
  const [includeModeler, setIncludeModeler] = useState(false);
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);

  useEffect(() => {
    // Reset states when the modal opens
    setPrice("0.00"); // Default price value
    setIncludeTemplate(false);
    setIncludeModeler(false);
  }, [isOpen]);

  const validateForm = useCallback(() => {
    const isValid = price !== "" && (includeTemplate || includeModeler);
    setIsSubmitEnabled(isValid);
  }, [price, includeTemplate, includeModeler]);

  useEffect(() => {
    validateForm();
  }, [price, includeTemplate, includeModeler, validateForm]);

  const handleModelerChange = useCallback((e) => {
    setIncludeModeler(e.target.checked);
  }, []);

  const handleCreate = () => {
    if (isSubmitEnabled) {
      onCreateProduct({
        price,
        includeTemplate,
        includeModeler
      });
      onClose();
    }
  };

  const handlePriceChange = useCallback((e) => {
    let value = e.target.value;
    // Allow only numbers, one dot, and two decimals
    if (value === "" || /^[0-9]*\.?[0-9]{0,2}$/.test(value)) {
      setPrice(value);
    }
  }, []);

  return (
    <Modal onClose={onClose} isOpen={isOpen}>
      <ModalHeader>{t("sellModal.title")}</ModalHeader>
      <ModalBody>
        <Block marginBottom="scale500">
          <Input
            value={price}
            onChange={handlePriceChange}
            placeholder={t("sellModal.inputPlaceholder")}
            startEnhancer="$"
          />
        </Block>
        <Block marginBottom="scale500">
          <Checkbox
            checked={includeTemplate}
            onChange={(e) => setIncludeTemplate(e.target.checked)}
          >
            {t("sellModal.includeTemplate")}
          </Checkbox>
        </Block>
        <Block marginBottom="scale500">
          <Checkbox
            checked={includeModeler}
            onChange={handleModelerChange}
          >
            {t("sellModal.includeModeler")}
          </Checkbox>
        </Block>
      </ModalBody>
      <ModalFooter>
        <ModalButton kind="tertiary" onClick={onClose}>
          {t("sellModal.cancelButton")}
        </ModalButton>
        <ModalButton disabled={!isSubmitEnabled} onClick={handleCreate}>
          {t("sellModal.createButton")}
        </ModalButton>
      </ModalFooter>
    </Modal>
  );
};
